<template>
  <gradient-wrapper>
    <form-card
      :top-bar="$vuetify.breakpoint.mdAndDown"
      :loading="loadingFetchServicerData"
    >
      <headline :text="loNotFoundTitleText" />
      <v-form
        ref="form"
        @submit.prevent
      >
        <sn-label
          class="mb-2"
          :title="loNotFoundLoEmailText"
          label-for="user-email"
        />
        <sn-text-field
          id="user-email"
          v-model="loEmail"
          :rules="rules.email"
          :error-messages="errorMessage"
          validate-on-blur
          :aria-label="loNotFoundLoEmailText"
          @focus="clearErrorMessage"
          @keyup.native.enter="continueClicked"
        />
      </v-form>
      <template #card-buttons>
        <template v-if="isCustomDomain">
          <v-col
            v-if="$vuetify.breakpoint.mdAndDown"
            class="pa-0"
          >
            <sn-btn
              :text="loNotFoundContinueButton"
              size="full-width"
              class="mb-4"
              @click="continueClicked"
            />
            <sn-btn
              class="px-6"
              :text="loNotFoundAssignFirstAvailableButton"
              type="secondary"
              size="full-width"
              @click="assignClicked"
            />
          </v-col>
          <v-row
            v-else
            no-gutters
            justify="space-between"
            align="center"
          >
            <sn-btn
              class="px-6"
              :text="loNotFoundAssignFirstAvailableButton"
              type="secondary"
              @click="assignClicked"
            />
            <sn-btn
              :text="loNotFoundContinueButton"
              :loading="btnLoading"
              @click="continueClicked"
            />
          </v-row>
        </template>
        <v-row v-else>
          <v-col cols="12">
            <sn-btn
              :text="loNotFoundContinueButton"
              size="full-width"
              @click="continueClicked"
            />
          </v-col>
        </v-row>
      </template>
    </form-card>
  </gradient-wrapper>
</template>

<script>
import GradientWrapper from './Shared/GradientWrapper.vue'
import fetchServicerMixin from './Shared/fetchServicerMixin'
import FormCard from './Shared/FormCard.vue'
import Headline from './Shared/Headline.vue'
import snValidationsService from '~/services/snValidationsService.js'
import brandThemeMixin from '~/components/common/brandThemeMixin'
import homehubMixin from './Shared/homehubMixin.js'

export default {
  name: 'LoNotFound',
  components: { GradientWrapper, FormCard, Headline },
  mixins: [fetchServicerMixin, brandThemeMixin, homehubMixin],
  data () {
    return {
      loEmail: this.$store?.loEmail,
      errorMessage: undefined,
      btnLoading: false,
      canTransitionHere: true,
      rules: {
        email: [
          (v) => !!v || this.loNotFoundEnterEmailText,
          (v) => this.emailIsValid || this.loNotFoundInvalidEmailText
        ]
      }
    }
  },
  computed: {
    emailIsValid () {
      return !!this.loEmail && snValidationsService.email(this.loEmail) === true
    },
    isCustomDomain () {
      return !['localhost', 'simplenexus'].some(str => window.location.host.includes(str))
    },
    loNotFoundTitleText () {
      return this.$store.borrowerWebContent?.loNotFoundTitleText
    },
    loNotFoundLoEmailText () {
      return this.$store.borrowerWebContent?.loNotFoundLoEmailText
    },
    loNotFoundContinueButton () {
      return this.$store.borrowerWebContent?.loNotFoundContinueButton
    },
    loNotFoundAssignFirstAvailableButton () {
      return this.$store.borrowerWebContent?.loNotFoundAssignFirstAvailableButton
    },
    loNotFoundEnterEmailText () {
      return this.$store.borrowerWebContent?.loNotFoundEnterEmailText || ''
    },
    loNotFoundInvalidEmailText () {
      return this.$store.borrowerWebContent?.loNotFoundInvalidEmailText || ''
    },
    loNotFoundLoNotFoundText () {
      return this.$store.borrowerWebContent?.loNotFoundLoNotFoundText
    }
  },
  mounted () {
    if (this.$route.query.fromnolo) this.errorMessage = this.loNotFoundLoNotFoundText
  },
  methods: {
    continueClicked () {
      if (!this.$refs.form.validate() || this.btnLoading) return
      this.btnLoading = true
      this.$store.loEmail = this.loEmail
      window.location = `/homehub/signup/${this.loEmail}?fromnolo=true`
    },
    assignClicked () {
      window.location = `/homehub/signup/${this.$store.defaultCode}?fromnolo=true`
    },
    clearErrorMessage () {
      this.errorMessage = undefined
    }
  }
}
</script>
